import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { objectToSnake } from 'ts-case-convert';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';
import {
  IClientNotificationOptions,
  IClientNotificationRule,
  INotificationPreference,
  INotificationTextUpdate,
} from 'src/app/models';

@Injectable({
  providedIn: 'root',
})
export class NotificationSettingsHttpService extends BaseHttpService {
  private baseURL = `notification-settings`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getClientRules(clientId: number) {
    return this.read(this.routerService.mount(`${this.baseURL}/clients/${clientId}`));
  }

  public updateClientRules(clientId: number, rules: IClientNotificationRule[]) {
    return this.update(objectToSnake({ rules }), this.routerService.mount(`${this.baseURL}/clients/${clientId}`));
  }

  public getClientTexts(clientId: number) {
    return this.read(this.routerService.mount(`${this.baseURL}/clients/${clientId}/texts`));
  }

  public updateClientTexts(clientId: number, texts: INotificationTextUpdate[]) {
    return this.update(objectToSnake({ texts }), this.routerService.mount(`${this.baseURL}/clients/${clientId}/texts`));
  }

  public getClientOptions(clientId: number) {
    return this.read(this.routerService.mount(`${this.baseURL}/clients/${clientId}/options`));
  }

  public updateClientOptions(clientId: number, options: IClientNotificationOptions) {
    return this.update(objectToSnake(options), this.routerService.mount(`${this.baseURL}/clients/${clientId}/options`));
  }

  public getOwnPreferences(clientId?: number) {
    return this.read(this.routerService.mount(`${this.baseURL}/me${this.clientQuery(clientId)}`));
  }

  public updateOwnPreferences(preferences: INotificationPreference[], clientId?: number) {
    return this.update(
      objectToSnake({ preferences }),
      this.routerService.mount(`${this.baseURL}/me${this.clientQuery(clientId)}`),
    );
  }

  private clientQuery(clientId?: number) {
    return clientId ? `?clientId=${clientId}` : '';
  }
}
